<template>
  <div class="server-tr">
    <div
      class="c_333 fs16"
      v-for="(item,index) in list"
      :key="index"
    >
      <div class="server-li-title text-align-center c_white">{{item.title}}</div>
      <div class="server-li-add text-align-center">{{item.participants}}</div>
      <div class="server-li-remarks text-align-center">
        <p style="text-align: left;  display: inline-block">{{item.content}}</p>
      </div>
      <div
        style="padding:44px 0;"
        v-if="index != (list.length-1)"
      >
        <img
          style="display:block;width:50px;height:50px;margin:0 auto;"
          src="@/image/index/icon_jt.png"
          alt
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showAll: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      list: [],
    };
  },
  created () {
    if (this.showAll) {
      this.list = [
        {
          title: "一、建立平台专项微信群",
          content:
            "智垒服务团队包括实施人员、技术人员、设计人员。客户专项团队包括客户方的平台（候选）负责人、后台管理员、调度人员、推广人员、司机主管，可兼任或逐步配齐人员。项目初期建议客户方的老板或高管亲自参与，提高执行力。",
          participants: "参与人员：智垒服务团队+客户专项团队",
        },
        {
          title: "二、品牌名称和账户注册",
          content:
            "A、确定平台的品牌名称，建议采用 本地地名+出行 作为平台名称，例如“深圳出行;     B、注册“XX出行”微信公众号;     C、	注册“XX出行”微信小程序;    D、开通用于收款的微信支付商户。",
          participants: "参与人员：智垒实施人员+平台负责人",
        },
        {
          title: "三、技术平台搭建",
          content:
            "服务器部署，生成平台专用的管理后台、小程序和司机端App，包含定制快车、数字公交、数字班车、智能出租车、智能旅游运输等产品系统。",
          participants: "参与人员：智垒技术人员",
        },
        {
          title: "四、基础数据录入",
          content:
            "在管理后台录入基础数据，包括：司机、车辆、调度、线路、站点、班次、价格等。",
          participants: "参与人员：智垒实施人员+后台管理员",
        },
        {
          title: "五、人员培训与演练",
          content: "对司机、调度、管理员进行软件操作培训。模拟后台排班、用户下单、班次调度（部分模式需要）、司机执行班次（接客、送客）、结束班次等全部操作流程。就演练过程中产生的问题进行总结和改进，确保正式运营万无一失。",
          participants: "参与人员：智垒实施人员+平台全部岗位",
        },
        {
          title: "六、制定推广方案",
          content: "制定平台正式运营前、运营初期、运营中长期的平台推广预算和方案，常用推广方式包括：员工推广、用户裂变、地推、线上广告等。广告文案、图片的构思和确认。宣传册、易拉宝、海报、单页等宣传物料的制作。",
          participants: "参与人员：智垒实施人员+平台负责人",
        },
        {
          title: "七、推广和试运营",
          content: "推广：执行推广方案、分析数据、调整推广策略。试运营：开放少量线路，分析数据和收集意见，调整班次时间、班次数量、站点、电子围栏等。",
          participants: "参与人员：智垒实施人员+平台全体人员",
        },
        {
          title: "八、正式运营和持续改进",
          content: "全部线路上线运营，优化流程，提升服务体验。持续技术运维保障平台安全、稳定。改进软件产品，确保平台技术领先。",
          participants: "参与人员：智垒技术人员+平台全体人员",
        }
      ];
    } else {
      this.list = [
        {
          title: "一、建立平台专项微信群",
          content:
            "智垒服务团队包括实施人员、技术人员、设计人员。客户专项团队包括客户方的平台（候选）负责人、后台管理员、调度人员、推广人员、司机主管，可兼任或逐步配齐人员。项目初期建议客户方的老板或高管亲自参与，提高执行力。",
          participants: "参与人员：智垒服务团队+客户专项团队",
        },
        {
          title: "二、品牌名称和账户注册",
          content:
            "A、确定平台的品牌名称，建议采用 本地地名+出行 作为平台名称，例如“深圳出行;     B、注册“XX出行”微信公众号;     C、	注册“XX出行”微信小程序;    D、开通用于收款的微信支付商户。",
          participants: "参与人员：智垒实施人员+平台负责人",
        }
      ];
    }
  },
  methods: {},
};
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>


// WEBPACK FOOTER //
// src/components/servertr/index.vue